import reportsTemplate from './reports.html';

export default angular
  .module('main.organizations.edit.tabs.reports', [])

  .directive('editOrganizationReportsTab', () => {
    return {
      restrict: 'E',
      template: reportsTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $state,
                   $q,
                   $filter,
                   utils,
                   config,
                   ToastsService,
                   PermissionsService,
                   NotificationService,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');
        const SELECTED_ORG_LOCAL_STORAGE_KEY = 'Selected-Org';

        $scope.orgInfo = utils.getStorageItem(SELECTED_ORG_LOCAL_STORAGE_KEY);
        $scope.dataProvider = EditOrganizationDataProvider.instance;
        const isAdminsEditor = PermissionsService.canIManageOrganizationAdmins();
        const reportCategories = config.getConfigByKey('reportGroupCategories');

        $scope.isParentOrganization = false;
        $scope.notificationGroups = [];

        angular.extend($scope, {
          toggleReportStatus: toggleReportStatus,
          editNotificationGroup: editNotificationGroup,
          gotoNotificationGroup: gotoNotificationGroup,
        });

        // Remove modals
        $scope.$on('$destroy', () => {
          $('#org-notification-group-modal').remove();
        });

        init();

        function init() {
          $scope.loading = true;
          $scope.reportsLoaded = false;

          // Prevent to load current tab if not enough permissions,
          // and drop to default organization 'contacts' tab
          if (!isAdminsEditor) {
            $scope.dataProvider.activeTab = 'contacts';
          }

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationReportGroupsResource.init(),
            initNotificationGroups(),
          ])
            .then(() => {
              initOrganizationReports();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initNotificationGroups() {
          return NotificationService.getNotificationGroups($scope.orgInfo.id)
            .then(data => {
              $scope.notificationGroups = (data && data.groups) || [];
            });
        }

        function initOrganizationReports() {
          $scope.isParentOrganization = !$scope.orgInfo.parentId;
          let reportGroups = angular.copy($scope.dataProvider.organizationReportGroupsResource.value || []);
          processReportGroups(reportGroups);
          initWatchers();
        }

        function initWatchers() {
          $scope.$watch('dataProvider.organizationReportGroupsResource.value', (reportGroups) => {
            if (reportGroups) {
              processReportGroups(reportGroups);
            }
          }, true);
        }

        function processReportGroups(reportGroups) {
          $scope.reportGroups = reportCategories
            .map(reportCategory => ({
              ...reportCategory,
              reports: reportGroups
                .filter(reportGroup => !reportCategory.exclude
                  ? !!reportGroup[reportCategory.attribute]
                  : !reportGroup[reportCategory.attribute])
                .map(reportGroup => ({
                  ...reportGroup,
                  editable: $scope.isParentOrganization && (!reportGroup.organizationId || reportGroup.organizationId === $scope.orgInfo.id) ? true : false,
                }))
            }))
            .filter(reportCategory => reportCategory.reports && reportCategory.reports.length);
          $scope.reportsLoaded = true;
        }

        function toggleReportStatus(group, $event, $index, $parent) {
          if (!$scope.reportsLoaded) {
            return;
          }

          $scope.reportsLoaded = false;
          let isActive = !!group.organizationId;

          $scope.dataProvider.setReportGroupStatus(group.id, !isActive)
            .then((data) => {
              let message = isActive ? $t('orgs.new.reports.statusInactive') : $t('orgs.new.reports.statusActive');
              ToastsService.success(null, message);

              // Trigger refresh menu
              $rootScope.$emit('refreshMenusEvent');

              $scope.reportsLoaded = true;
            }, (err) => {
              ToastsService.error(null, $t('orgs.new.reports.statusError'));
              $scope.reportsLoaded = true;
            });
        }

        function editNotificationGroup(reportGroup, $event) {
          $scope.selectedReportGroup = reportGroup;
          let notificationGroup = $scope.notificationGroups.find(g => g.groupId === reportGroup.notificationGroupId)
          $scope.selectedNotificationGroupId = notificationGroup ? notificationGroup.groupId : null;

          $('#org-notification-group-modal').modal({
            autofocus: false,
            closable: false,
            detachable: true,
            onApprove: changeNotificationGroup
          }).modal('show');
        }

        function changeNotificationGroup() {
          if (angular.equals($scope.selectedNotificationGroupId, $scope.selectedReportGroup.notificationGroupId)) {
            return;
          }

          $scope.reportsLoaded = false;
          return $scope.dataProvider.setReportGroupStatus($scope.selectedReportGroup.id, 1, $scope.selectedNotificationGroupId)
            .then(() => {
              initOrganizationReports();
              ToastsService.success(null, $t('orgs.edit.reports.modal.confirm'));
            }).catch(err => handleError(err));
        }

        /**
         * Handle error and stop loading
         */
        function handleError(err) {
          $scope.reportsLoaded = true;
          return utils.handleApiError(err);
        }

        function gotoNotificationGroup(reportGroup, $event) {
          if (!reportGroup || !reportGroup.notificationGroupId) {
            return;
          }

          $state.go('main.notifications.groups.edit', {
            from: 'organization',
            fromTab: $scope.dataProvider.activeTab,
            groupId: reportGroup.notificationGroupId,
          });
        }

      }
    };
  })
  .name;
